import React, { ComponentType } from 'react'
import { Select as FuiSelect } from '@fluentui/react-components'
import { Option } from './options'

export type SelectProps = {
    options: Option[]
    value?: string
    disabled?: boolean,
    placeholder?: string
    onChange?: (val?: string) => void
}

export const Select: ComponentType<SelectProps> = ({ options, value, onChange, disabled }) => (
    <FuiSelect
        disabled={disabled}
        value={value}
        onChange={onChange && ((_, v) => onChange(v.value))}
    >
        {options.map((o) => (
            <option key={o.value} value={o.value}>
                {o.label}
            </option>
        ))}
    </FuiSelect>
)
